import { render, staticRenderFns } from "./user-Info.vue?vue&type=template&id=07e271dc&"
import script from "./user-Info.vue?vue&type=script&lang=js&"
export * from "./user-Info.vue?vue&type=script&lang=js&"
import style0 from "./user-Info.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports